module.exports = __webpack_public_path__ + "img/3_cover2.a97bc83c.png";